import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./assets/images/logo/logo.png";
const TEAL = "#00c4b4";
const TEAL2 = "#00e5d4";
const DARK = "#060d14";
const CARD = "rgba(255,255,255,0.04)";
const APK_URL = `${process.env.PUBLIC_URL}/base-apk.apk`;

function BrandLogo({ height = 36 }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <svg width={height} height={height} viewBox="0 0 40 40" fill="none">
        <rect
          x="1"
          y="1"
          width="38"
          height="38"
          rx="10"
          stroke={TEAL}
          strokeWidth="2"
        />
        <path
          d="M11 24l6-6 4 4 8-8"
          stroke={TEAL}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M21 14h8v8"
          stroke={TEAL}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      <span
        style={{
          fontSize: height * 0.5,
          fontWeight: 900,
          letterSpacing: -0.5,
          whiteSpace: "nowrap",
        }}
      >
        <span style={{ color: "#fff" }}>Trade</span>
        <span style={{ color: TEAL }}>4You</span>
      </span>
    </div>
  );
}

const journeySteps = [
  {
    icon: (
      <svg
        width="38"
        height="38"
        fill="none"
        viewBox="0 0 24 24"
        stroke={TEAL}
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        />
      </svg>
    ),
    title: "Open an Account",
    desc: "Register quickly with your email and phone number. Verification takes under 60 seconds.",
  },
  {
    icon: (
      <svg
        width="38"
        height="38"
        fill="none"
        viewBox="0 0 24 24"
        stroke={TEAL}
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
    title: "Make a Deposit",
    desc: "Fund your account from as little as $5 using crypto, bank transfer, or 50+ payment methods.",
  },
  {
    icon: (
      <svg
        width="38"
        height="38"
        fill="none"
        viewBox="0 0 24 24"
        stroke={TEAL}
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
        />
      </svg>
    ),
    title: "Start Trading",
    desc: "Pick an asset, predict UP or DOWN, and collect up to 95% profit on every winning trade.",
  },
];

const benefits = [
  {
    icon: (
      <svg
        width="34"
        height="34"
        fill="none"
        viewBox="0 0 24 24"
        stroke={TEAL}
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
    title: "30 Minutes",
    desc: "Get your account ready and start trading in as little as 30 minutes from registration.",
  },
  {
    icon: (
      <svg
        width="34"
        height="34"
        fill="none"
        viewBox="0 0 24 24"
        stroke={TEAL}
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
        />
      </svg>
    ),
    title: "Win Rewards",
    desc: "Earn bonuses, cashback, and weekly prizes. Top traders win from our $20,000 prize pool.",
  },
  {
    icon: (
      <svg
        width="34"
        height="34"
        fill="none"
        viewBox="0 0 24 24"
        stroke={TEAL}
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
        />
      </svg>
    ),
    title: "Customer Support",
    desc: "24/7 live support via chat, email, and phone in multiple languages — always here for you.",
    highlight: true,
  },
  {
    icon: (
      <svg
        width="34"
        height="34"
        fill="none"
        viewBox="0 0 24 24"
        stroke={TEAL}
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
    ),
    title: "Robot Balance",
    desc: "AI-powered trading robots manage your portfolio and execute trades automatically for optimal returns.",
  },
  {
    icon: (
      <svg
        width="34"
        height="34"
        fill="none"
        viewBox="0 0 24 24"
        stroke={TEAL}
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
        />
      </svg>
    ),
    title: "Protection",
    desc: "Bank-grade 256-bit SSL encryption, 2FA, cold wallet storage — your funds are always secure.",
  },
];

const tradeCategories = [
  {
    label: "Crypto",
    desc: "Bitcoin, Ethereum, XRP and 50+ cryptocurrencies with up to 90% payout.",
    icon: "₿",
    color: "#f7931a",
  },
  {
    label: "Metals",
    desc: "Gold, Silver, Platinum — trade precious metals with tight spreads.",
    icon: "Au",
    color: "#ffd700",
  },
  {
    label: "Commodities",
    desc: "Oil, Gas, Coffee, Sugar — profit from global commodity price movements.",
    icon: "🌾",
    color: "#a3e635",
  },
  {
    label: "Forex",
    desc: "EUR/USD, GBP/JPY and 30+ currency pairs. High liquidity, fast execution.",
    icon: "€",
    color: TEAL,
  },
  {
    label: "Indices",
    desc: "S&P 500, NASDAQ, DAX — trade the world's top market indices.",
    icon: "📊",
    color: "#818cf8",
  },
  {
    label: "Oil",
    desc: "WTI and Brent crude oil — ride energy market volatility for big wins.",
    icon: "🛢",
    color: "#fb923c",
  },
];

const awards = [
  {
    year: "2024",
    title: "Best Forex Broker",
    org: "Asia Forex Awards",
    img: "./assets/image.png",
  },
  {
    year: "2023",
    title: "Best New Broker",
    org: "Global Trading Summit",
    img: "./assets/image2.png",
  },
  {
    year: "2023",
    title: "Top CFD Broker",
    org: "FX Intelligence Awards",
    img: "./assets/image3.png",
  },
  {
    year: "2024",
    title: "Best Trading Platform",
    org: "Finance Magnates",
    img: "./assets/image4.png",
  },
];

const newsLogos = [
  { name: "BanklessTimes", color: "#e06c47" },
  { name: "Yahoo! Finance", color: "#6001d2" },
  { name: "DIGITAL JOURNAL", color: "#888" },
];

export default function LandingPage() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [tick, setTick] = useState(0);

  const downloadApk = () => {
    const link = document.createElement("a");
    link.href = APK_URL;
    link.download = "TradeWin.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const root = document.getElementById("root");
    root?.classList.add("landing-mode");
    return () => root?.classList.remove("landing-mode");
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 2000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      style={{
        fontFamily: "'Inter','Segoe UI',sans-serif",
        background: DARK,
        color: "#fff",
        overflowX: "hidden",
        minHeight: "100vh",
      }}
    >
      <style>{`
        * { box-sizing: border-box; }
        html, body { margin: 0; padding: 0; scroll-behavior: smooth; }
        @keyframes fadeUp   { from { opacity:0; transform:translateY(24px) } to { opacity:1; transform:translateY(0) } }
        @keyframes floatY   { 0%,100% { transform:translateY(0) } 50% { transform:translateY(-10px) } }
        @keyframes glow     { 0%,100% { box-shadow:0 0 20px rgba(0,196,180,.3) } 50% { box-shadow:0 0 40px rgba(0,196,180,.7) } }
        @keyframes pulse    { 0%,100% { opacity:1;transform:scale(1) } 50% { opacity:.5;transform:scale(1.25) } }
        @keyframes spin3d   { from { transform:rotateY(0deg) } to { transform:rotateY(360deg) } }
        @keyframes shimmer  { 0% { background-position:200% center } 100% { background-position:-200% center } }
        .hero-title { font-size: clamp(32px,5vw,64px); font-weight:900; line-height:1.1; letter-spacing:-1.5px; }
        .btn-primary { background:linear-gradient(135deg,${TEAL},#007a72); color:#fff; border:none; cursor:pointer; font-weight:700; transition:all .2s; }
        .btn-primary:hover { transform:translateY(-2px); box-shadow:0 0 32px rgba(0,196,180,.5)!important; }
        .btn-outline { background:transparent; border:1.5px solid ${TEAL}; color:${TEAL}; cursor:pointer; font-weight:600; transition:all .2s; }
        .btn-outline:hover { background:rgba(0,196,180,.1); }
        .card-hover:hover { transform:translateY(-4px)!important; border-color:rgba(0,196,180,.4)!important; box-shadow:0 16px 48px rgba(0,196,180,.12)!important; }
        .teal-text { background:linear-gradient(90deg,${TEAL},${TEAL2}); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
        @media(max-width:768px){ .hero-grid { grid-template-columns:1fr!important; } .two-col { grid-template-columns:1fr!important; } }
        @media(max-width:600px){ .trade-grid { grid-template-columns:1fr 1fr!important; } .benefit-grid { grid-template-columns:1fr!important; } }
        .stat-badge { animation:glow 3s ease-in-out infinite; }
        ::-webkit-scrollbar { width:6px; } ::-webkit-scrollbar-track { background:${DARK}; } ::-webkit-scrollbar-thumb { background:rgba(0,196,180,.3); border-radius:3px; }
      `}</style>

      {/* ── NAVBAR ── */}
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 5%",
          height: 68,
          background: scrolled ? "rgba(6,13,20,0.97)" : "rgba(6,13,20,0.85)",
          backdropFilter: "blur(20px)",
          borderBottom: `1px solid rgba(0,196,180,${scrolled ? ".2" : ".1"})`,
          transition: "all .3s",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {/* <BrandLogo height={36} /> */}
          <img className="!h-10 !w-50" src={logo} />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button
            className="btn-outline"
            onClick={downloadApk}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "9px 20px",
              borderRadius: 8,
              fontSize: 14,
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download App
          </button>
          <button
            className="btn-primary"
            onClick={() => navigate("/login")}
            style={{
              padding: "10px 26px",
              borderRadius: 8,
              fontSize: 14,
              boxShadow: "0 0 20px rgba(0,196,180,.3)",
            }}
          >
            Get Started
          </button>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section
        id="hero"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          padding: "100px 5% 80px",
          position: "relative",
          overflow: "hidden",
          background: `radial-gradient(ellipse 100% 80% at 60% 40%, rgba(0,196,180,.1) 0%, rgba(0,100,90,.06) 40%, ${DARK} 70%)`,
        }}
      >
        {/* Background glow orbs */}
        <div
          style={{
            position: "absolute",
            top: "15%",
            right: "8%",
            width: 480,
            height: 480,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(0,196,180,.12) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "10%",
            left: "5%",
            width: 300,
            height: 300,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(0,196,180,.07) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />

        <div
          className="hero-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 60,
            alignItems: "center",
            maxWidth: 1200,
            margin: "0 auto",
            width: "100%",
          }}
        >
          {/* Left */}
          <div style={{ animation: "fadeUp .8s ease both" }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: `rgba(0,196,180,.12)`,
                border: `1px solid rgba(0,196,180,.3)`,
                borderRadius: 50,
                padding: "5px 16px",
                fontSize: 12,
                color: TEAL,
                fontWeight: 700,
                marginBottom: 24,
                letterSpacing: 1,
                textTransform: "uppercase",
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: TEAL,
                  boxShadow: `0 0 8px ${TEAL}`,
                  animation: "pulse 2s infinite",
                  flexShrink: 0,
                }}
              />
              Live Trading Platform
            </div>
            <h1 className="hero-title" style={{ marginBottom: 24 }}>
              Your Path to <span className="teal-text">Profitable</span>
              <br />
              Trading Start Here
            </h1>
            <p
              style={{
                fontSize: 16,
                color: "rgba(255,255,255,.6)",
                lineHeight: 1.8,
                maxWidth: 480,
                marginBottom: 36,
              }}
            >
              Join thousands of traders on a platform built for speed, security,
              and success. Trade crypto, forex, metals & more — with payouts up
              to <strong style={{ color: TEAL }}>95%</strong>.
            </p>
            <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
              <button
                className="btn-primary"
                onClick={downloadApk}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "13px 32px",
                  borderRadius: 10,
                  fontSize: 16,
                  boxShadow: "0 0 32px rgba(0,196,180,.4)",
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Download App
              </button>
              <button
                className="btn-outline"
                onClick={() => navigate("/login")}
                style={{ padding: "13px 32px", borderRadius: 10, fontSize: 16 }}
              >
                Sign In
              </button>
            </div>

            {/* Stats */}
            <div
              style={{
                display: "flex",
                gap: 40,
                marginTop: 52,
                flexWrap: "wrap",
              }}
            >
              {[
                { n: "Evolving", l: "Trading Pairs" },
                { n: "40+", l: "Countries" },
                { n: "105+", l: "Instruments" },
                { n: "300+", l: "Trading Signals" },
              ].map((s) => (
                <div key={s.l}>
                  <div
                    style={{
                      fontSize: "clamp(18px,2.5vw,26px)",
                      fontWeight: 900,
                      color: TEAL,
                    }}
                  >
                    {s.n}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: "rgba(255,255,255,.45)",
                      marginTop: 3,
                      letterSpacing: 0.5,
                    }}
                  >
                    {s.l}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Animated 3D visual */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              animation: "floatY 5s ease-in-out infinite",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "min(420px,90vw)",
                height: "min(420px,90vw)",
              }}
            >
              {/* Outer ring */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  borderRadius: "50%",
                  border: `1.5px solid rgba(0,196,180,.2)`,
                  background: `radial-gradient(circle, rgba(0,196,180,.08) 0%, transparent 70%)`,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  inset: "8%",
                  borderRadius: "50%",
                  border: `1px solid rgba(0,196,180,.12)`,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  inset: "18%",
                  borderRadius: "50%",
                  border: `1px solid rgba(0,196,180,.08)`,
                  background: `radial-gradient(circle, rgba(0,196,180,.06) 0%, transparent 60%)`,
                }}
              />
              {/* Center glow */}
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                  width: "45%",
                  height: "45%",
                  borderRadius: "50%",
                  background: `radial-gradient(circle, rgba(0,196,180,.35) 0%, rgba(0,196,180,.1) 50%, transparent 70%)`,
                  boxShadow: `0 0 60px rgba(0,196,180,.4)`,
                  animation: "glow 3s ease-in-out infinite",
                }}
              />
              {/* Orbit dots */}
              {[0, 60, 120, 180, 240, 300].map((deg, i) => (
                <div
                  key={i}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    background: i % 2 === 0 ? TEAL : "rgba(0,196,180,.5)",
                    boxShadow: `0 0 8px ${TEAL}`,
                    transform: `rotate(${deg + tick * 3}deg) translateX(calc(min(210px,45vw) - 5px)) translateY(-5px)`,
                    transition: "transform 1s linear",
                  }}
                />
              ))}
              {/* Chart line inside */}
              <div
                style={{
                  position: "absolute",
                  inset: "25%",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* <svg
                  viewBox="0 0 100 50"
                  style={{ width: "80%", opacity: 0.7 }}
                >
                  <polyline
                    points="0,45 15,30 30,38 45,15 60,25 75,10 90,18 100,12"
                    fill="none"
                    stroke={TEAL}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <polyline
                    points="0,45 15,30 30,38 45,15 60,25 75,10 90,18 100,12 100,50 0,50"
                    fill={`rgba(0,196,180,.15)`}
                  />
                </svg> */}
                <video
                  src="https://winprofx.com/assets/about-CXP4ybJ1.webm"
                  autoPlay
                  muted
                  loop
                  playsInline
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
              {/* Floating badges */}
              <div
                style={{
                  position: "absolute",
                  top: "10%",
                  right: "5%",
                  background: "rgba(6,13,20,.9)",
                  border: `1px solid rgba(0,196,180,.3)`,
                  borderRadius: 10,
                  padding: "8px 14px",
                  fontSize: 13,
                  fontWeight: 700,
                  color: TEAL,
                  backdropFilter: "blur(10px)",
                }}
              >
                +95% Payout
              </div>
              <div
                style={{
                  position: "absolute",
                  bottom: "12%",
                  left: "2%",
                  background: "rgba(6,13,20,.9)",
                  border: `1px solid rgba(0,196,180,.3)`,
                  borderRadius: 10,
                  padding: "8px 14px",
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#fff",
                  backdropFilter: "blur(10px)",
                }}
              >
                🟢 Markets Open
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── JOURNEY ── */}
      <section
        style={{
          padding: "80px 5%",
          background: "rgba(255,255,255,.025)",
          borderTop: `1px solid rgba(0,196,180,.08)`,
          borderBottom: `1px solid rgba(0,196,180,.08)`,
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ marginBottom: 48 }}>
            <p
              style={{
                fontSize: 13,
                color: TEAL,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: 2,
                marginBottom: 10,
              }}
            >
              Get Started
            </p>
            <h2
              style={{
                fontSize: "clamp(24px,3.5vw,42px)",
                fontWeight: 800,
                lineHeight: 1.2,
                letterSpacing: "-.5px",
                marginBottom: 12,
              }}
            >
              Your Journey to Trading
              <br />
              <span className="teal-text">Starts Here With Us</span>
            </h2>
          </div>
          <div
            className="two-col"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3,1fr)",
              gap: 24,
            }}
          >
            {journeySteps.map((s, i) => (
              <div
                key={i}
                className="card-hover"
                style={{
                  background: CARD,
                  border: `1px solid rgba(0,196,180,.12)`,
                  borderRadius: 18,
                  padding: "32px 28px",
                  transition: "all .25s",
                }}
              >
                <div
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: 16,
                    background: `rgba(0,196,180,.1)`,
                    border: `1px solid rgba(0,196,180,.2)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 20,
                  }}
                >
                  {s.icon}
                </div>
                <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: 10 }}>
                  {s.title}
                </h3>
                <p
                  style={{
                    fontSize: 14,
                    color: "rgba(255,255,255,.55)",
                    lineHeight: 1.7,
                    marginBottom: 0,
                  }}
                >
                  {s.desc}
                </p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 36, textAlign: "center" }}>
            <button
              className="btn-primary"
              onClick={() => navigate("/register")}
              style={{
                padding: "13px 36px",
                borderRadius: 10,
                fontSize: 15,
                boxShadow: "0 0 28px rgba(0,196,180,.35)",
              }}
            >
              Get Started Free →
            </button>
          </div>
        </div>
      </section>

      {/* ── BENEFITS ── */}
      <section
        id="benefits"
        style={{
          padding: "90px 5%",
          background: `radial-gradient(ellipse 80% 50% at 50% 100%, rgba(0,196,180,.07) 0%, ${DARK} 65%)`,
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <p
            style={{
              fontSize: 13,
              color: TEAL,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 2,
              marginBottom: 10,
            }}
          >
            Why Choose Us
          </p>
          <h2
            style={{
              fontSize: "clamp(24px,3.5vw,42px)",
              fontWeight: 800,
              lineHeight: 1.2,
              letterSpacing: "-.5px",
              marginBottom: 48,
            }}
          >
            Benefits of Trading <span className="teal-text">With Us</span>
          </h2>
          <div
            className="benefit-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
              gap: 20,
            }}
          >
            {benefits.map((b, i) => (
              <div
                key={i}
                className="card-hover"
                style={{
                  background: b.highlight
                    ? `linear-gradient(135deg, rgba(0,196,180,.15), rgba(0,100,90,.1))`
                    : CARD,
                  border: `1px solid ${b.highlight ? "rgba(0,196,180,.35)" : "rgba(0,196,180,.1)"}`,
                  borderRadius: 18,
                  padding: "28px 24px",
                  transition: "all .25s",
                  boxShadow: b.highlight
                    ? "0 0 32px rgba(0,196,180,.1)"
                    : "none",
                }}
              >
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 14,
                    background: `rgba(0,196,180,.1)`,
                    border: `1px solid rgba(0,196,180,.2)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 18,
                  }}
                >
                  {b.icon}
                </div>
                <h3
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    marginBottom: 8,
                    color: b.highlight ? TEAL : "#fff",
                  }}
                >
                  {b.title}
                </h3>
                <p
                  style={{
                    fontSize: 13,
                    color: "rgba(255,255,255,.55)",
                    lineHeight: 1.7,
                  }}
                >
                  {b.desc}
                </p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 40, textAlign: "center" }}>
            <button
              className="btn-primary"
              onClick={() => navigate("/register")}
              style={{
                padding: "13px 36px",
                borderRadius: 10,
                fontSize: 15,
                boxShadow: "0 0 28px rgba(0,196,180,.35)",
              }}
            >
              Start Trading Now →
            </button>
          </div>
        </div>
      </section>

      {/* ── MT5 DOWNLOAD ── */}
      <section id="mt5" style={{ padding: "0 5% 80px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr auto",
              gap: 40,
              alignItems: "center",
              background: `linear-gradient(135deg, rgba(0,196,180,.12) 0%, rgba(0,50,45,.15) 100%)`,
              border: `1px solid rgba(0,196,180,.2)`,
              borderRadius: 24,
              padding: "48px 52px",
              boxShadow: "0 0 60px rgba(0,196,180,.07)",
              flexWrap: "wrap",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: 12,
                  color: TEAL,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: 2,
                  marginBottom: 10,
                }}
              >
                Mobile Trading
              </p>
              <h2
                style={{
                  fontSize: "clamp(22px,3vw,38px)",
                  fontWeight: 800,
                  lineHeight: 1.2,
                  marginBottom: 14,
                }}
              >
                Download <span className="teal-text">Application</span>
                <br />
                For Mobile
              </h2>
              <p
                style={{
                  fontSize: 14,
                  color: "rgba(255,255,255,.6)",
                  lineHeight: 1.7,
                  maxWidth: 420,
                  marginBottom: 28,
                }}
              >
                TradeWin is recommended to download and use the MetaTrader 5
                platform because it gives us the ability to use advanced tools
                for trading.
              </p>
              <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                {/* App Store */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    background: "#000",
                    border: "1px solid rgba(255,255,255,.2)",
                    borderRadius: 10,
                    padding: "10px 20px",
                    cursor: "pointer",
                  }}
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                  <div>
                    <div
                      style={{ fontSize: 10, color: "rgba(255,255,255,.6)" }}
                    >
                      Download on the
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 700 }}>
                      App Store
                    </div>
                  </div>
                </div>
                {/* Play Store */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    background: "#000",
                    border: "1px solid rgba(255,255,255,.2)",
                    borderRadius: 10,
                    padding: "10px 20px",
                    cursor: "pointer",
                  }}
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                    <path d="M3.18 23.76c.28.16.6.24.93.2l12.29-7.1-2.54-2.54-10.68 9.44zm15.9-10.4L16.76 12l2.32-1.36 2-1.16c.5.5.76 1.1.74 1.72-.02.6-.29 1.2-.74 1.66l-1.96-1.16h-.04zM3.03.2C2.67.36 2.39.66 2.24 1.04L13.98 12.8 16.52 10.26 4.05.3C3.74.1 3.36.04 3.03.2zm.15 11.58v9.44L13.85 12z" />
                  </svg>
                  <div>
                    <div
                      style={{ fontSize: 10, color: "rgba(255,255,255,.6)" }}
                    >
                      Get it on
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 700 }}>
                      Google Play
                    </div>
                  </div>
                </div>
                {/* Direct APK Download */}
                <div
                  onClick={downloadApk}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    background: TEAL,
                    border: `1px solid ${TEAL}`,
                    borderRadius: 10,
                    padding: "10px 20px",
                    cursor: "pointer",
                  }}
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#06110f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  <div>
                    <div style={{ fontSize: 10, color: "rgba(6,17,15,.7)" }}>
                      Direct Download
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#06110f" }}>
                      APK File
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Phone mockup */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                animation: "floatY 4s ease-in-out infinite",
              }}
            >
              <div
                style={{
                  width: 120,
                  height: 200,
                  borderRadius: 20,
                  background:
                    "linear-gradient(160deg,rgba(0,196,180,.3),rgba(0,50,45,.4))",
                  border: `2px solid rgba(0,196,180,.4)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 0 40px rgba(0,196,180,.2)",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 40,
                    height: 4,
                    borderRadius: 2,
                    background: "rgba(255,255,255,.2)",
                  }}
                />
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={TEAL}
                  strokeWidth={1.2}
                >
                  <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHAT CAN YOU TRADE ── */}
      <section
        id="what-trade"
        style={{
          padding: "80px 5%",
          background: `radial-gradient(ellipse 80% 50% at 30% 50%, rgba(0,196,180,.06) 0%, ${DARK} 60%)`,
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <p
            style={{
              fontSize: 13,
              color: TEAL,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 2,
              marginBottom: 10,
            }}
          >
            Markets
          </p>
          <h2
            style={{
              fontSize: "clamp(24px,3.5vw,42px)",
              fontWeight: 800,
              lineHeight: 1.2,
              letterSpacing: "-.5px",
              marginBottom: 14,
            }}
          >
            What you can <span className="teal-text">Trade?</span>
          </h2>
          <p
            style={{
              fontSize: 15,
              color: "rgba(255,255,255,.55)",
              maxWidth: 520,
              lineHeight: 1.7,
              marginBottom: 48,
            }}
          >
            Discover seamless trading with all assets transparently and advanced
            technology built for your financial success.
          </p>
          <div
            className="trade-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3,1fr)",
              gap: 20,
            }}
          >
            {tradeCategories.map((c) => (
              <div
                key={c.label}
                className="card-hover"
                style={{
                  background: CARD,
                  border: `1px solid rgba(0,196,180,.1)`,
                  borderRadius: 18,
                  padding: "28px 24px",
                  transition: "all .25s",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    background: `radial-gradient(circle, ${c.color}15 0%, transparent 70%)`,
                    transform: "translate(20%,-20%)",
                  }}
                />
                <div style={{ fontSize: 36, marginBottom: 14 }}>{c.icon}</div>
                <h3
                  style={{
                    fontSize: 17,
                    fontWeight: 700,
                    marginBottom: 8,
                    color: c.color,
                  }}
                >
                  {c.label}
                </h3>
                <p
                  style={{
                    fontSize: 13,
                    color: "rgba(255,255,255,.5)",
                    lineHeight: 1.6,
                  }}
                >
                  {c.desc}
                </p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 36, textAlign: "center" }}>
            <button
              className="btn-primary"
              onClick={() => navigate("/register")}
              style={{
                padding: "13px 36px",
                borderRadius: 10,
                fontSize: 15,
                boxShadow: "0 0 28px rgba(0,196,180,.35)",
              }}
            >
              Start Trading →
            </button>
          </div>
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section
        id="about"
        style={{
          padding: "90px 5%",
          background: `linear-gradient(180deg, ${DARK} 0%, rgba(0,20,18,.6) 50%, ${DARK} 100%)`,
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div
            className="two-col"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 60,
              alignItems: "center",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: 12,
                  color: TEAL,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: 2,
                  marginBottom: 10,
                }}
              >
                About TradeWin
              </p>
              <h2
                style={{
                  fontSize: "clamp(22px,3vw,38px)",
                  fontWeight: 800,
                  lineHeight: 1.2,
                  marginBottom: 20,
                }}
              >
                At TradeWin, we offer a{" "}
                <span className="teal-text">secure online</span> trading
                environment
              </h2>
              <p
                style={{
                  fontSize: 15,
                  color: "rgba(255,255,255,.6)",
                  lineHeight: 1.8,
                  marginBottom: 20,
                }}
              >
                Our platform combines cutting-edge technology with deep market
                knowledge, enabling traders of all levels to achieve their
                financial goals.
              </p>
              <ul style={{ listStyle: "none", padding: 0, margin: "0 0 28px" }}>
                {[
                  "Best-in-class trading execution speed",
                  "Transparent pricing with no hidden fees",
                  "Dedicated portfolio management tools",
                  "Industry-leading security protocols",
                ].map((item) => (
                  <li
                    key={item}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      fontSize: 14,
                      color: "rgba(255,255,255,.7)",
                      marginBottom: 12,
                    }}
                  >
                    <span
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        background: `rgba(0,196,180,.2)`,
                        border: `1px solid ${TEAL}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        fontSize: 11,
                        color: TEAL,
                      }}
                    >
                      ✓
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <button
                className="btn-primary"
                onClick={() => navigate("/register")}
                style={{
                  padding: "12px 28px",
                  borderRadius: 10,
                  fontSize: 15,
                  boxShadow: "0 0 24px rgba(0,196,180,.35)",
                }}
              >
                Learn More →
              </button>
            </div>
            {/* 3D Video */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: "min(400px,90vw)",
                  height: "min(400px,90vw)",
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: `2px solid rgba(0,196,180,.25)`,
                  boxShadow: `0 0 60px rgba(0,196,180,.2), inset 0 0 60px rgba(0,196,180,.05)`,
                  position: "relative",
                }}
              >
                <video
                  src="https://winprofx.com/assets/about-CXP4ybJ1.webm"
                  autoPlay
                  muted
                  loop
                  playsInline
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "radial-gradient(circle at 50% 50%, transparent 40%, rgba(6,13,20,.6) 100%)",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── AWARDS ── */}
      <section
        style={{
          padding: "80px 5%",
          background: `radial-gradient(ellipse 80% 50% at 50% 50%, rgba(0,196,180,.06) 0%, ${DARK} 65%)`,
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto", textAlign: "center" }}>
          <p
            style={{
              fontSize: 12,
              color: TEAL,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 2,
              marginBottom: 10,
            }}
          >
            Recognition
          </p>
          <h2
            style={{
              fontSize: "clamp(22px,3vw,38px)",
              fontWeight: 800,
              lineHeight: 1.2,
              marginBottom: 12,
            }}
          >
            TradeWin Broker with{" "}
            <span className="teal-text">Award-Winning Excellence</span>
          </h2>
          <p
            style={{
              fontSize: 14,
              color: "rgba(255,255,255,.5)",
              maxWidth: 560,
              margin: "0 auto 48px",
              lineHeight: 1.7,
            }}
          >
            Our group has earned many awards in recognition of our dedication to
            continually growing our product and service range.
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
              gap: 20,
              maxWidth: 900,
              margin: "0 auto",
            }}
          >
            {awards.map((a, i) => (
              <div
                key={i}
                style={{
                  background: CARD,
                  border: `1px solid rgba(0,196,180,.15)`,
                  borderRadius: 18,
                  padding: "28px 20px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    // width: 60,
                    // height: 60,
                    borderRadius: "50%",
                    background: `rgba(0,196,180,.12)`,
                    border: `2px solid rgba(0,196,180,.3)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                    fontSize: 22,
                  }}
                >
                  <img src={a.img} alt={a.title} />
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: TEAL,
                    fontWeight: 700,
                    letterSpacing: 1,
                    marginBottom: 6,
                    textTransform: "uppercase",
                  }}
                >
                  {a.year}
                </div>
                <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>
                  {a.title}
                </div>
                <div style={{ fontSize: 12, color: "rgba(255,255,255,.4)" }}>
                  {a.org}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── NEWS & INSIGHTS ── */}
      <section
        id="news"
        style={{
          padding: "80px 5%",
          borderTop: `1px solid rgba(0,196,180,.07)`,
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <p
            style={{
              fontSize: 13,
              color: TEAL,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 2,
              marginBottom: 10,
            }}
          >
            Media
          </p>
          <h2
            style={{
              fontSize: "clamp(22px,3vw,38px)",
              fontWeight: 800,
              lineHeight: 1.2,
              marginBottom: 14,
            }}
          >
            News & <span className="teal-text">Insights</span>
          </h2>
          <p
            style={{
              fontSize: 14,
              color: "rgba(255,255,255,.5)",
              maxWidth: 480,
              lineHeight: 1.7,
              marginBottom: 40,
            }}
          >
            Our platform is recognized and featured by leading financial media
            outlets worldwide.
          </p>
          <div
            style={{
              display: "flex",
              gap: 28,
              flexWrap: "wrap",
              alignItems: "center",
              marginBottom: 56,
            }}
          >
            {newsLogos.map((n) => (
              <div
                key={n.name}
                style={{
                  background: CARD,
                  border: `1px solid rgba(255,255,255,.07)`,
                  borderRadius: 12,
                  padding: "14px 24px",
                  fontSize: 16,
                  fontWeight: 800,
                  color: n.color,
                  letterSpacing: 0.5,
                }}
              >
                {n.name}
              </div>
            ))}
          </div>

          {/* Payments */}
          <div
            style={{
              background: CARD,
              border: `1px solid rgba(0,196,180,.1)`,
              borderRadius: 20,
              padding: "40px 36px",
            }}
          >
            <div
              className="two-col"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 40,
                alignItems: "center",
              }}
            >
              <div>
                <h3
                  style={{
                    fontSize: "clamp(18px,2.5vw,28px)",
                    fontWeight: 800,
                    marginBottom: 12,
                    lineHeight: 1.3,
                  }}
                >
                  Effortless Fund Flow: Swift Deposits and Seamless{" "}
                  <span className="teal-text">Withdrawals</span>
                </h3>
                <p
                  style={{
                    fontSize: 14,
                    color: "rgba(255,255,255,.55)",
                    lineHeight: 1.7,
                    marginBottom: 24,
                  }}
                >
                  Experience financial fluidity with TradeWin. Fast deposits and
                  rapid withdrawals processed within hours, not days.
                </p>
                <div
                  style={{
                    display: "flex",
                    gap: 16,
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  {/* Crypto icons */}
                  {["₿", "Ξ", "◎", "⬡"].map((icon, i) => (
                    <div
                      key={i}
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        background: `rgba(0,196,180,.12)`,
                        border: `1px solid rgba(0,196,180,.2)`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 16,
                      }}
                    >
                      {icon}
                    </div>
                  ))}
                </div>
              </div>
              {/* <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <div style={{ background: "linear-gradient(135deg,#1a237e,#283593)", borderRadius: 14, padding: "18px 22px", position: "relative", overflow: "hidden" }}>
                  <div style={{ position: "absolute", top: "50%", right: -30, width: 120, height: 120, borderRadius: "50%", background: "rgba(255,255,255,.05)", transform: "translateY(-50%)" }} />
                  <div style={{ fontSize: 20, fontWeight: 900, color: "#fff", letterSpacing: 3, marginBottom: 6 }}>VISA</div>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,.5)", letterSpacing: 2 }}>**** **** **** 4829</div>
                </div>
                <div style={{ background: "linear-gradient(135deg,#b71c1c,#c62828)", borderRadius: 14, padding: "18px 22px", position: "relative", overflow: "hidden", display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#e53935", opacity: .9 }} />
                  <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#ffb300", marginLeft: -16, opacity: .9 }} />
                  <span style={{ fontSize: 14, fontWeight: 700, color: "#fff", marginLeft: 4 }}>Mastercard</span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* ── TRADE TO WIN + FREE ANALYSIS ── */}
      <section
        style={{
          padding: "80px 5%",
          background: `radial-gradient(ellipse 80% 50% at 70% 50%, rgba(0,196,180,.06) 0%, ${DARK} 65%)`,
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div
            className="two-col"
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}
          >
            {/* Trade to WIN */}
            <div
              style={{
                background: `linear-gradient(135deg, rgba(0,196,180,.12), rgba(0,50,45,.1))`,
                border: `1px solid rgba(0,196,180,.2)`,
                borderRadius: 20,
                padding: "40px 32px",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div style={{ fontSize: 48, marginBottom: 16 }}>🏆</div>
              <h3
                style={{
                  fontSize: "clamp(18px,2.5vw,26px)",
                  fontWeight: 800,
                  marginBottom: 12,
                }}
              >
                Trade to <span className="teal-text">WIN</span>
              </h3>
              <p
                style={{
                  fontSize: 14,
                  color: "rgba(255,255,255,.6)",
                  lineHeight: 1.7,
                  marginBottom: 24,
                }}
              >
                Trade the financial markets and win. Our platform gives you the
                tools, signals, and leverage you need to succeed with every
                trade.
              </p>
              <button
                className="btn-primary"
                onClick={() => navigate("/register")}
                style={{ padding: "11px 26px", borderRadius: 10, fontSize: 14 }}
              >
                Start Trading →
              </button>
            </div>

            {/* Free Technical Analysis */}
            <div
              style={{
                background: CARD,
                border: `1px solid rgba(0,196,180,.12)`,
                borderRadius: 20,
                padding: "40px 32px",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div style={{ fontSize: 48, marginBottom: 16 }}>📈</div>
              <h3
                style={{
                  fontSize: "clamp(18px,2.5vw,26px)",
                  fontWeight: 800,
                  marginBottom: 12,
                }}
              >
                Free Technical <span className="teal-text">Analysis</span>
              </h3>
              <p
                style={{
                  fontSize: 14,
                  color: "rgba(255,255,255,.6)",
                  lineHeight: 1.7,
                  marginBottom: 24,
                }}
              >
                Identify chart patterns and sharpen your trading skills with our
                comprehensive free analysis tools and real-time market insights.
              </p>
              <button
                className="btn-outline"
                onClick={() => navigate("/register")}
                style={{ padding: "11px 26px", borderRadius: 10, fontSize: 14 }}
              >
                Explore Analysis →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── DEMO / EMBARK ON MASTERY ── */}
      <section
        style={{
          padding: "80px 5%",
          borderTop: `1px solid rgba(0,196,180,.07)`,
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div
            style={{
              background: `linear-gradient(135deg, rgba(0,196,180,.1) 0%, rgba(0,50,45,.12) 100%)`,
              border: `1px solid rgba(0,196,180,.2)`,
              borderRadius: 24,
              padding: "56px 48px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 32,
              boxShadow: "0 0 60px rgba(0,196,180,.06)",
            }}
          >
            <div style={{ maxWidth: 560 }}>
              <p
                style={{
                  fontSize: 12,
                  color: TEAL,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: 2,
                  marginBottom: 10,
                }}
              >
                Practice Risk-Free
              </p>
              <h2
                style={{
                  fontSize: "clamp(22px,3vw,38px)",
                  fontWeight: 800,
                  lineHeight: 1.2,
                  marginBottom: 16,
                }}
              >
                Embark on Mastery: Unleash Your Skills with the{" "}
                <span className="teal-text">TradeWin Demo Experience!</span>
              </h2>
              <p
                style={{
                  fontSize: 15,
                  color: "rgba(255,255,255,.6)",
                  lineHeight: 1.7,
                  marginBottom: 28,
                }}
              >
                Practice with virtual funds, test strategies, and build
                confidence before going live. Zero risk — all the experience of
                real trading.
              </p>
              <button
                className="btn-primary"
                onClick={() => navigate("/register")}
                style={{
                  padding: "13px 32px",
                  borderRadius: 10,
                  fontSize: 15,
                  boxShadow: "0 0 28px rgba(0,196,180,.35)",
                }}
              >
                Try Demo Account Free →
              </button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {[
                { icon: "💰", label: "$10,000", sub: "Virtual Demo Balance" },
                {
                  icon: "⚡",
                  label: "Real Markets",
                  sub: "Live Prices & Charts",
                },
                { icon: "🔁", label: "Unlimited", sub: "Practice Trades" },
              ].map((item) => (
                <div
                  key={item.label}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    background: "rgba(0,196,180,.08)",
                    border: `1px solid rgba(0,196,180,.15)`,
                    borderRadius: 12,
                    padding: "14px 20px",
                    minWidth: 220,
                  }}
                >
                  <span style={{ fontSize: 22 }}>{item.icon}</span>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 700 }}>
                      {item.label}
                    </div>
                    <div
                      style={{ fontSize: 12, color: "rgba(255,255,255,.45)" }}
                    >
                      {item.sub}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <div
        style={{
          background: "#040a10",
          borderTop: `1px solid rgba(0,196,180,.1)`,
          padding: "60px 5% 0",
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ marginBottom: 20, textAlign: "center" }}>
            <div
              style={{
                fontSize: "clamp(36px,6vw,72px)",
                fontWeight: 900,
                letterSpacing: 4,
                background: `linear-gradient(90deg, rgba(255,255,255,.08) 0%, rgba(255,255,255,.15) 50%, rgba(255,255,255,.08) 100%)`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                lineHeight: 1,
              }}
            >
              TradeWin
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 40,
            }}
          >
            {/* <BrandLogo height={36} /> */}
            <img className="!h-10 !w-50" src={logo} />
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))",
              gap: 40,
              paddingBottom: 48,
              borderBottom: `1px solid rgba(255,255,255,.06)`,
            }}
          >
            {[
              {
                title: "Explore",
                links: ["Home", "About Us", "Promotion", "Demo Account"],
              },
              {
                title: "Markets",
                links: ["Forex Trading", "Crypto", "Commodities", "Indices"],
              },
              {
                title: "Support",
                links: ["Contact Us", "Help Center", "Live Chat", "FAQ"],
              },
              {
                title: "Address",
                links: [
                  "Suite 305, Griffith Corporate",
                  "Centre Beachmont,",
                  "Kingstown, St. Vincent",
                  "& the Grenadines",
                ],
              },
            ].map((col) => (
              <div key={col.title}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: "#fff",
                    marginBottom: 18,
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  {col.title}
                </div>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {col.links.map((l) => (
                    <li
                      key={l}
                      style={{
                        fontSize: 13,
                        color: "rgba(255,255,255,.45)",
                        marginBottom: 10,
                        cursor: "pointer",
                        lineHeight: 1.5,
                      }}
                    >
                      {l}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Payment logos row */}
          <div
            style={{
              display: "flex",
              gap: 20,
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              padding: "24px 0",
              borderBottom: `1px solid rgba(255,255,255,.05)`,
            }}
          >
            {["VISA", "Mastercard", "₿ Bitcoin", "Ξ Ethereum", "USDT"].map(
              (p) => (
                <div
                  key={p}
                  style={{
                    background: "rgba(255,255,255,.04)",
                    border: "1px solid rgba(255,255,255,.08)",
                    borderRadius: 8,
                    padding: "6px 16px",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "rgba(255,255,255,.5)",
                  }}
                >
                  {p}
                </div>
              ),
            )}
          </div>

          <div
            style={{
              padding: "20px 0 28px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            <div style={{ fontSize: 12, color: "rgba(255,255,255,.3)" }}>
              © 2025 TRADEWIN. All rights reserved.
            </div>
            <div
              style={{
                fontSize: 11,
                color: "rgba(255,255,255,.2)",
                maxWidth: 480,
                textAlign: "right",
                lineHeight: 1.6,
              }}
            >
              Trading involves significant risk and is not suitable for all
              investors. Past performance does not guarantee future results.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
